var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99975 6.99975H0.99975C0.866336 6.99173 0.732739 7.0121 0.607779 7.05952C0.482819 7.10694 0.369339 7.18032 0.274831 7.27483C0.180323 7.36934 0.106938 7.48282 0.0595197 7.60778C0.0121017 7.73274 -0.00826999 7.86634 -0.000250349 7.99975V14.9997C-0.00826999 15.1332 0.0121017 15.2668 0.0595197 15.3917C0.106938 15.5167 0.180323 15.6302 0.274831 15.7247C0.369339 15.8192 0.482819 15.8926 0.607779 15.94C0.732739 15.9874 0.866336 16.0078 0.99975 15.9997H1.99975V6.99975Z",
    fill: "#2D7FFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.9995H9V1.9995C9.01604 1.73267 8.9753 1.46548 8.88046 1.21556C8.78562 0.965638 8.63885 0.738678 8.44984 0.549662C8.26082 0.360646 8.03386 0.213875 7.78394 0.119039C7.53402 0.0242034 7.26683 -0.01654 7 -0.000500699L4 6.9995V15.9995H12C12.6894 16.0082 13.3595 15.7716 13.8907 15.332C14.4219 14.8924 14.7796 14.2784 14.9 13.5995L15.9 8.3995C15.9706 8.11267 15.9747 7.81348 15.9119 7.52483C15.8492 7.23618 15.7212 6.96571 15.5379 6.7341C15.3545 6.5025 15.1206 6.3159 14.8541 6.18857C14.5875 6.06125 14.2954 5.99658 14 5.9995Z",
    fill: "#2D7FFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4362b2039cdd201b3398e50b81ed264f.svg";
export { ForwardRef as ReactComponent };